import React, { useEffect, useState } from 'react';
import { TextField, Button, Grid, Typography, Box, CircularProgress, MenuItem, Select, FormControl, InputLabel } from '@mui/material';

import Layout from '../../components/layout';
import { db } from '../../firebaseconf';
import { collection, query, where, getDocs, addDoc } from "firebase/firestore";
import Header from '../../components/header';
import Alert from '../../components/alert';
import { COLLEGE_SEMESTERS } from '../../utils/semesterDefaults';

export default function TeacherForm() {
    const [semesters, setSemesters] = useState([]);
    const [sessionalSubjects, setSessionalSubjects] = useState([]);
    const [selectedSemester, setSelectedSemester] = useState('');
    const [loading, setLoading] = useState(false);
    const [alertVisible, setAlertVisible] = useState(false);
    const [newTeacher, setNewTeacher] = useState({
        Name: '', branch: '', subject: '', semester: '', phone: '', email: ''
    });

    useEffect(() => {
        const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
        if (!loggedUser || !loggedUser.institution_id) return;
        
        const subjectsRef = collection(db, 'institutions', loggedUser.institution_id, 'subjects');
        
        getDocs(subjectsRef).then(snapshot => {
            if (snapshot.empty) {
                // Use fallback semesters if no subjects found
                setSemesters(COLLEGE_SEMESTERS);
            } else {
                const data = snapshot.docs.map(doc => doc.data());
                const semesterKeys = [...new Set(data.map(s => s.semester))];
                setSemesters(semesterKeys.length > 0 ? semesterKeys : COLLEGE_SEMESTERS);
            }
        }).catch(err => {
            console.error('Error fetching semesters:', err);
            setSemesters(COLLEGE_SEMESTERS);
        });
    }, []);

    useEffect(() => {
        if (selectedSemester) {
            const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
            if (!loggedUser || !loggedUser.institution_id) return;
            
            const q = query(
                collection(db, 'institutions', loggedUser.institution_id, 'subjects'),
                where('semester', '==', selectedSemester)
            );
            getDocs(q).then(snapshot => {
                const data = snapshot.docs.map(doc => doc.data().name || doc.data().subject_name);
                setSessionalSubjects(data);
            });
        }
    }, [selectedSemester]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewTeacher(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSemesterChange = (e) => {
        const semester = e.target.value;
        setSelectedSemester(semester);
        setNewTeacher(prevState => ({
            ...prevState,
            semester: semester,
            subject: ''
        }));
    };

    const handleSubjectChange = (e) => {
        const subject = e.target.value;
        setNewTeacher(prevState => ({
            ...prevState,
            subject: subject
        }));
    };

    const handleAddTeacher = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
        if (!loggedUser || !loggedUser.institution_id) return;

        try {
            await addDoc(collection(db, 'institutions', loggedUser.institution_id, 'teachers'), {
                ...newTeacher,
                institution_id: loggedUser.institution_id,
                created_at: new Date()
            });
            console.log("Teacher added successfully");
            setNewTeacher({
                Name: '', branch: '', subject: '', semester: '', phone: '', email: ''
            });
            setAlertVisible(true);
            setSelectedSemester('');
            setTimeout(() => setAlertVisible(false), 3000);
        } catch (error) {
            console.error("Error adding teacher:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <Header title="Add Teacher" />
            <Box component="section" sx={{ p: 5 }}>
                {alertVisible && <Alert message="Teacher Added successfully!" type="success" color="success" />}
                {loading && <CircularProgress sx={{ display: 'block', margin: '10px auto' }} />}
                <form onSubmit={handleAddTeacher}>
                    <Typography variant="h5" gutterBottom>
                        Add Teacher Details
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Teacher Name"
                                name="Name"
                                value={newTeacher.Name}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Branch"
                                name="branch"
                                value={newTeacher.branch}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel>Semester</InputLabel>
                                <Select
                                    value={selectedSemester}
                                    onChange={handleSemesterChange}
                                    label="Semester"
                                >
                                    {semesters.map((semester, index) => (
                                        <MenuItem key={index} value={semester}>
                                            {semester}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel>Subject</InputLabel>
                                <Select
                                    value={newTeacher.subject}
                                    onChange={handleSubjectChange}
                                    name="subject"
                                    label="Subject"
                                >
                                    {sessionalSubjects.map((subjectObj, index) => (
                                        <MenuItem key={index} value={subjectObj.subject}>
                                            {subjectObj.subject} {/* Display the subject name */}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Phone No."
                                name="phone"
                                value={newTeacher.phone}
                                onChange={handleChange}
                                variant="outlined"
                                type="tel"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Email"
                                name="email"
                                value={newTeacher.email}
                                onChange={handleChange}
                                variant="outlined"
                                type="email"
                            />
                        </Grid>
                    </Grid>
                    <Box mt={3}>
                        <Button type="submit" variant="contained" color="primary" disabled={loading}>
                            Submit
                        </Button>
                    </Box>
                </form>
            </Box>
        </Layout>
    );
}
